import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import {
  fadeInDown,
  fadeInGrow,
  growRight,
  slideUp,
} from './end-of-level-congratulation-animations';

@Component({
  selector: 'lp2-end-of-level-congratulation',
  templateUrl: './end-of-level-congratulation.component.html',
  styleUrls: ['./end-of-level-congratulation.component.scss'],
  animations: [fadeInDown, slideUp, growRight, fadeInGrow],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EndOfLevelCongratulationComponent {
  @Input() title: string;
  @Input() subtitle: string;
  @Input() body: string;
  @Input() buttonText: string;
  @Input() level: number;
  @Output() buttonPress = new EventEmitter<void>();

  displayText = false;
  displayConfetti = false;

  @HostBinding('class')
  public get class() {
    if (this.displayText) {
      return 'animation-done';
    }
  }

}



// WEBPACK FOOTER //
// ./ts/app/shared/end-of-level-congratulation/end-of-level-congratulation.component.ts